import '@gjensidige/core-fonts';

import React, { useEffect } from 'react';

//import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import tracker from './tracking';
import { AppStep } from './types/enums';
import CheckWrapper from './components/checks/CheckWrapper';
import Footer from './components/Footer';
import Layout from './components/Layout';
import Start from './components/Start';
import Summary from './components/summary/Summary';
import { useCheckListContext } from './context/CheckListProvider';

function App() {
  const { appStep } = useCheckListContext();

  useEffect(() => {
    tracker.init();
  }, []);

  return (
    <>
      {appStep === AppStep.SUMMARY ? (
        <Summary />
      ) : (
        <>
          <Layout>
            {appStep === AppStep.START ? <Start /> : <CheckWrapper />}
          </Layout>
          <Footer />
        </>
      )}
    </>
  );

  // return (
  //   <>
  //     <Router>
  //       <Switch>
  //         <Route exact path="/" render={() => <><Layout><Start/></Layout><Footer /></>} />
  //         <Route exact path="/summary" component={Summary} />
  //         <Route path="/:step" render={() => <><Layout><CheckWrapper/></Layout><Footer /></>} />
  //       </Switch>
  //     </Router>

  //   </>
  // );
}

export default App;
